<template>
  <v-app id="inspire">
    <router-view />
    <ErrorDialog/>
  </v-app>
</template>

<script>
import ErrorDialog from '@/components/ErrorDialog.vue';

export default {
  name: 'App',
  components: {
    ErrorDialog,
  },
  props: {
    source: String,
  },
  // created() {
  //   this.$vuetify.theme.dark = true;
  // },
};
</script>
